import * as React from 'react'

const SvgWalletBucket = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="14"
      fill="none"
      viewBox="0 0 16 14"
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M12.667 5.667H3.333m9.334 0l1.242 2.071c.279.464.418.696.49.946.065.222.09.452.075.682-.016.26-.102.517-.273 1.03l-.138.416c-.263.787-.394 1.18-.637 1.471-.215.257-.49.456-.802.578-.353.139-.768.139-1.597.139H4.973c-.83 0-1.244 0-1.597-.139a1.999 1.999 0 01-.802-.578c-.243-.29-.375-.684-.637-1.471l-.138-.416c-.172-.513-.257-.77-.274-1.03a2 2 0 01.075-.682c.073-.25.212-.482.49-.946l1.243-2.071m9.334 0l.278-.974c.132-.462.198-.692.146-.875a.667.667 0 00-.29-.385c-.162-.1-.402-.1-.882-.1H4.081c-.48 0-.72 0-.882.1a.667.667 0 00-.29.385c-.052.183.014.413.146.875l.278.974M8 3.333H5.643c-.348 0-.68-.14-.926-.39A1.346 1.346 0 014.333 2c0-.354.138-.693.384-.943.245-.25.578-.39.926-.39C7.476.667 8 3.333 8 3.333zm0 0h2.357c.347 0 .68-.14.926-.39s.384-.59.384-.943c0-.354-.138-.693-.384-.943a1.298 1.298 0 00-.926-.39C8.524.667 8 3.333 8 3.333z"
      ></path>
    </svg>
  )
}

export default SvgWalletBucket
